import { Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DMS_TOOLTIP_Z_INDEX } from '../../config/antdTheme';
import { ActionStatus } from '../../types/actionTypes';
import { getActionStatusLabel } from '../../utils/actionStatusConfig';
import { ACTION_STATUS_ICON_SIZE, ActionStatusGlyph } from './actionStatusGlyphs';

interface ActionStatusIconProps {
  status: ActionStatus | null | undefined;
  className?: string;
  size?: number;
}

const ActionStatusIcon: React.FC<ActionStatusIconProps> = ({ status, className, size = ACTION_STATUS_ICON_SIZE }) => {
  const { t } = useTranslation();
  const label = getActionStatusLabel(status, t);

  return (
    <Tooltip title={label} placement="top" zIndex={DMS_TOOLTIP_Z_INDEX}>
      <span className={`action-status-icon${className ? ` ${className}` : ''}`} role="img" aria-label={label}>
        <ActionStatusGlyph status={status} size={size} />
      </span>
    </Tooltip>
  );
};

export default ActionStatusIcon;
